import { RubricEditor } from "@/components/rubric-editor";
import { useAdminKey } from "@/hooks/use-auth";
import type { PatchChallengeInput, RubricCheck } from "@/lib/api";

import { SectionCard } from "./section-card";
import { useChallenge, useChallengeState } from "./use-challenge";

/**
 * The rubric, with the room it needs: the text on the left, the server's reading of it and
 * the sample runs on the right. Points are computed when read, so saving re-scores the
 * leaderboard at once.
 */
export function AdminChallengeScoring() {
  const { challenge, refetch } = useChallenge();
  const adminKey = useAdminKey();
  const [form, set, reset] = useChallengeState((c) => ({ rubric: c.rubric, check: null as RubricCheck | null }));

  const patch: PatchChallengeInput = {};
  if (form.rubric !== challenge.rubric) patch.rubric = form.rubric;
  const problem =
    form.check === null
      ? form.rubric === challenge.rubric
        ? null
        : "Waiting for the server to read the draft…"
      : form.check.ok
        ? null
        : `Line ${form.check.problem?.line}: ${form.check.problem?.message}`;

  return (
    <SectionCard
      title="Scoring"
      description="What a run earns, and for what. Saving re-scores every run and the leaderboard immediately."
      patch={patch}
      problem={patch.rubric === undefined ? null : problem}
      onSaved={refetch}
      onReset={reset}
    >
      {adminKey ? (
        <RubricEditor
          id="s-rubric"
          value={form.rubric}
          onChange={(rubric) => set((f) => ({ ...f, rubric }))}
          simulator={challenge.simulator}
          adminKey={adminKey}
          onChecked={(check) => set((f) => ({ ...f, check }))}
        />
      ) : null}
    </SectionCard>
  );
}
